import React, { useEffect, useState } from "react"
import { Tooltip } from "@kit/design/tooltip"
import { useStaticFeature } from "hooks/use-feature"
import { IconButton } from "@kit/design/button"

export function StatusBanner() {
  const [status, setStatus] = useState(null)
  const reactBannerEnabled = useStaticFeature(
    "status_page_react_banner"
  ).enabled

  useEffect(() => {
    if (!reactBannerEnabled) return

    const controller = new AbortController()

    async function fetchStatus() {
      const statusPageUrl = "https://status.kitstag.com/api/v1/summary"
      try {
        const response = await fetch(statusPageUrl, {
          credentials: "omit",
          signal: controller.signal
        })
        if (!response.ok) return

        const data = await response.json()
        const ongoing = data.ongoing_incidents || []
        const maintenances = data.in_progress_maintenances || []

        if (ongoing.length || maintenances.length) {
          setStatus({
            title:
              ongoing[0]?.name || maintenances[0]?.name || "Service status",
            href: data.page_url || new URL(statusPageUrl).origin
          })
        }
      } catch (error) {
        // Swallow other errors silently; the banner is best-effort.
      }
    }

    fetchStatus()

    return () => controller.abort()
  }, [reactBannerEnabled])

  if (!status) return null

  return (
    <Tooltip>
      <Tooltip.Trigger
        delay={0}
        render={props => (
          <IconButton
            is="plain"
            icon="alert-triangle"
            href={status.href}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute top-1/2 -translate-y-1/2 left-full ml-2 text-orange-400 hover:text-orange-600 hover:no-underline"
            {...props}
          />
        )}
      ></Tooltip.Trigger>
      <Tooltip.Content position="bottom">{status.title}</Tooltip.Content>
    </Tooltip>
  )
}
